import React from 'react';
import cls from 'classnames';

import { TextArea as TextAreaTPA, TextAreaProps } from 'wix-ui-tpa/cssVars';

import classes from './TextArea.scss';

interface ITextFieldProps extends TextAreaProps {
  wired?: boolean;
}

export function TextArea(props: ITextFieldProps) {
  const { className, wired, ...rest } = props;

  return (
    <TextAreaTPA
      newErrorMessage
      className={cls(classes.root, className, {
        [classes.wired]: wired,
      })}
      {...rest}
    />
  );
}

TextArea.displayName = 'wui/TextArea';
